import { DatePicker } from 'antd';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
// This will help to make moment library work with antd DatePicker otherwise it would not work properly. more details: https://github.com/ant-design/ant-design/issues/40669
const MyDatePicker = DatePicker.generatePicker(momentGenerateConfig);

export default MyDatePicker;